import React, { useEffect, useState } from "react";
import { Input, Button, Row, Col, Form, Select, Layout } from "antd";
import { Link, useNavigate } from "react-router-dom";
import './styles.css';
import { ClearOutlined, SearchOutlined, HeartOutlined } from "@ant-design/icons";
import { AllStates } from "../../../Utils/AllStates";
import { AllSectors } from "../../../Utils/AllSectors";
import { AllBeneficiary } from "../../../Utils/AllBeneficiaries";
import useCan from "../../../Hooks/useCan";

const { Item } = Form;
const { Option } = Select;

interface Grant {
    id: string | number;
    title: string;
    description: string;
    isFavorite?: boolean;
}
interface LineFilterProps {
    grants: Grant[];
}

const LineFilter: React.FC<LineFilterProps> = ({ grants }) => {
    const [showFavorites, setShowFavorites] = useState(false);
    const [form] = Form.useForm();
    const [search, setSearch] = useState("");
    const [location, setLocation] = useState("");
    const [sector, setSector] = useState("");
    const [beneficiary, setBeneficiary] = useState("");
    const [status, setStatus] = useState("");
    const externalUsers = useCan({rolesCan: [ "Master", "Technician", "Financial", "HumanResources"]})
    const toggleFavorites = () => {
        setShowFavorites(!showFavorites);
    };
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    function handleFavToggle() {
        if(externalUsers){
            navigate("/grantsSearcher/grants", { state: { justFavorites: true } });
        }else{
            setShowFavorites(!showFavorites);
            if (!showFavorites) {
                navigate("/grantsSearcher/grants", { state: { justFavorites: true } });
            } else {            
                navigate("/grantsSearcher/grants", { state: { justFavorites: false } });
            }
        }
    }
    
    const filteredGrants = showFavorites
        ? grants.filter(grant => grant.isFavorite)
        : grants;
        
    function clearForm() {
        form.resetFields();
        setSearch("");
        setLocation("");
        setSector("");
        setBeneficiary("");
        setStatus("");
    }
    let description: string

    function descripctionLines(){
        if(externalUsers){
            description = "Exibir Linhas Favoritas"
        }else{
            if(showFavorites){
                description = "Exibir Todas"
            }else{
                description = "Exibir Linhas Favoritas"
            }
        }
      
        return description;
    }
   
    return (
        <Layout style={{
            background: 'white',
            padding: '12px',
            marginTop: '12px',
            borderRadius: '16px'
        }}>
            <Form form={form} layout="vertical">
                <Row gutter={[16, 16]} align="middle">
                    <Col span={12}>
                        <Item label="Palavras Chaves" name="search">
                            <Input
                                placeholder="Digite as palavras-chaves ..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </Item>
                    </Col>
                    
                    {!externalUsers && 
                    <Col span={4}>
                    <Link to="/grantsSearcher/grants" state={{ SearchText: search, location, sector, beneficiary, status }}>
                            <Button type="primary" style={{ borderRadius: '8px' }} block >
                                <SearchOutlined /> <span>Buscar</span>
                            </Button>
                        </Link>
                        </Col>
                    }
                   
                    <Col span={4}>
                        <Button onClick={clearForm} type="default" style={{ backgroundColor: '#D9D9D9', borderRadius: '8px' }} block>
                            <ClearOutlined /> <span>Limpar Filtros</span>
                        </Button>
                    </Col>
                    <Col span={4}>
                        <Button onClick={handleFavToggle} style={{ backgroundColor: '#00AEFF', borderRadius: '8px' }} block>
                            <HeartOutlined style={{ color: '#FFFFFF' }} />
                            <span style={{ color: '#FFFFFF' }}>
                                {descripctionLines()}
                            </span>
                        </Button>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} align="middle">
                    {/* Setores */}
                    <Col span={12}>
                        <Item label="Setores" name="sector">
                            <Select
                                placeholder="Selecione um setor"
                                options={AllSectors}
                                onChange={(value) => setSector(value)}
                                allowClear
                            ></Select>
                        </Item>
                    </Col>
                    {/* Localizações */}
                    <Col span={12}>
                        <Item label="Localizações" name="location">
                            <Select
                                placeholder="Selecione uma localização"
                                options={AllStates}
                                onChange={(value) => setLocation(value)}
                                allowClear
                            ></Select>
                        </Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} align="middle">
                    {/* Status */}
                    <Col span={12}>
                        <Item label="Status" name="status">
                            <Select
                                placeholder="Selecione um status"
                                value={status}
                                onChange={(value) => setStatus(value)}
                                allowClear
                            >
                                <Option value="status1">Ativo</Option>
                                <Option value="status2">Desativado</Option>
                            </Select>
                        </Item>
                    </Col>
                    {/* Tipo de Beneficiário */}
                    <Col span={12}>
                        <Item label="Tipo de Beneficiário" name="BeneficiaryKind">
                            <Select placeholder="Selecione um tipo de beneficiário" options={AllBeneficiary} allowClear />
                        </Item>
                    </Col>
                </Row>
            </Form>
        </Layout>
    )
}
export default LineFilter;